import { toPairs } from "lodash";

export default function getMyUpsolveEntryUrl(params:{[key:string]:string}) {
  const queryString = toPairs(params || {})
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return queryString ? `${UPSOLVE_FILER_URL}/intro?${queryString}` : process.env.UPSOLVE_FILER_URL||"";
}
